import { jsx as _jsx } from "react/jsx-runtime";
import { FormControl as ChakraFormControl, } from '@chakra-ui/react';
/**
 * FormControl provides context such as isInvalid, isDisabled, and isRequired to form elements.
 * Commonly used in form elements such as input, select, textarea, etc.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/formcontrol
 */
export function FormControl({ children, ...props }) {
    return _jsx(ChakraFormControl, { ...props, children: children });
}
//# sourceMappingURL=formcontrol.js.map